import { render, staticRenderFns } from "./documentMaster.vue?vue&type=template&id=34c90c4a"
import script from "./documentMaster.vue?vue&type=script&lang=js"
export * from "./documentMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c90c4a')) {
      api.createRecord('34c90c4a', component.options)
    } else {
      api.reload('34c90c4a', component.options)
    }
    module.hot.accept("./documentMaster.vue?vue&type=template&id=34c90c4a", function () {
      api.rerender('34c90c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/documentMaster.vue"
export default component.exports